import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useUser } from "@/auth/useUser";
import ErrorMessage, {
  FullPageError,
} from "@/components/common/errors/errorMessage";
import { isPublicRoute } from "@/utils/router";

type Props = {
  title: string;
  authDescription: string;
  noAuthDescription: string;
};

export default function ErrorView({
  title,
  authDescription,
  noAuthDescription,
}: Props) {
  const [isAfterHydration, setIsAfterHydration] = useState(false);
  const { asPath } = useRouter();

  useEffect(() => {
    setIsAfterHydration(true);
  }, []);

  // asPath for 404 page is different for the client and server
  // to avoid hydration mismatch, we render bare error message without buttons
  // and only after hydration on the client we can render the correct version
  if (!isAfterHydration || isPublicRoute(asPath)) {
    return (
      <FullPageError>
        <ErrorMessage title={title} description={noAuthDescription} />
      </FullPageError>
    );
  }

  return (
    <FullPageError>
      <AuthErrorView
        title={title}
        authDescription={authDescription}
        noAuthDescription={noAuthDescription}
      />
    </FullPageError>
  );
}

function AuthErrorView({ title, authDescription, noAuthDescription }: Props) {
  const { user, loading } = useUser();
  const isLoggedIn = !!user;

  return (
    <ErrorMessage
      title={title}
      description={isLoggedIn ? authDescription : noAuthDescription}
      showSpinner={loading}
      showReportIssueButton={!loading && isLoggedIn}
      showLoginButtons={!loading && !isLoggedIn}
    />
  );
}
